export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-col/index.js